import { defineProperty as _defineProperty, typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import chroma from 'chroma-js';
import { borderWidths } from './border-widths.esm.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';

function safeColor(color) {
  if (typeof color === 'string') return color;
  if (_typeof(color) === 'object' && THEME_UI_DEFAULT_KEY in color) return color[THEME_UI_DEFAULT_KEY];
  return '#fff';
}
var shadowSettings = {
  qtrBlur: '0 0 4px',
  ethBlur: '0 0 2px',
  halfBlur: '0 0 8px',
  qtrBlurRise: '0 2px 4px',
  ethBlurRise: '0 2px 6px',
  halfBlurRise: '0 2px 8px',
  bottomOnly: '0 3px 4px -2px'
};
function isShadowKey(subject) {
  return Object.keys(shadowSettings).includes(subject);
}
function generateBoxShadow(color) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [{
    alpha: 0.4,
    offset: 'qtrBlurRise'
  }, {
    alpha: 0.2,
    offset: 'default'
  }];
  function getSection(section) {
    var offset = section.offset,
      alpha = section.alpha;
    return isShadowKey(offset) ? "".concat(shadowSettings[offset], " ").concat(chroma(safeColor(color)).alpha(alpha).css()) : "0 0 0 ".concat(borderWidths[offset], " ").concat(chroma(safeColor(color)).alpha(alpha).css());
  }
  return offset.reduce(function (acc, cur) {
    return "".concat(acc).concat(acc.length > 0 ? ' ,' + getSection(cur) : getSection(cur));
  }, '');
}
function getShadows(colors) {
  var _black, _primary, _secondary;
  return {
    "default": generateBoxShadow(colors.black, [{
      offset: 'qtrBlur',
      alpha: 0.1
    }]),
    defaultRise: generateBoxShadow(colors.black),
    defaultRaiseTop: 'rgb(64 64 64) 0px -4px 12px -8px',
    text: generateBoxShadow(colors.text, [{
      offset: 'qtrBlur',
      alpha: 0.2
    }]),
    textBottomOnly: "".concat(shadowSettings.bottomOnly, " ").concat(chroma(safeColor(colors.text)).alpha(0.2).css()),
    textRise: "".concat(shadowSettings.qtrBlurRise, " ").concat(chroma(safeColor(colors.text)).alpha(0.2).css(), ", 0 0 0 ").concat(borderWidths["default"], " ").concat(chroma(safeColor(colors.text)).alpha(0.2).css()),
    textThick: "".concat(shadowSettings.halfBlur, " ").concat(chroma(safeColor(colors.text)).alpha(0.3).css()),
    textNormal: "0 0 ".concat(safeColor(colors.text)),
    textShadow: "0 0 1px ".concat(safeColor(colors.text)),
    textPrimary: "0 0 1px ".concat(safeColor(colors.primary)),
    textWhite: "0 0 1px ".concat(safeColor(colors.white)),
    textDanger: "0 0 1px ".concat(safeColor(colors.danger)),
    black: (_black = {}, _defineProperty(_black, THEME_UI_DEFAULT_KEY, generateBoxShadow(colors.black)), _defineProperty(_black, "inset", "inset 0px 0px 1px ".concat(colors.black)), _black),
    primary: (_primary = {}, _defineProperty(_primary, THEME_UI_DEFAULT_KEY, "".concat(shadowSettings.qtrBlur, " ").concat(safeColor(colors.primary))), _defineProperty(_primary, "rise", generateBoxShadow(colors.primary)), _defineProperty(_primary, "inset", "inset ".concat(shadowSettings.ethBlur, " ").concat(chroma(safeColor(colors.primary)).alpha(0.2).css())), _defineProperty(_primary, "thin", "".concat(shadowSettings.ethBlur, " ").concat(chroma(safeColor(colors.primary)).alpha(0.1).css())), _defineProperty(_primary, "thick", "".concat(shadowSettings.halfBlur, " ").concat(chroma(safeColor(colors.primary)).alpha(0.3).css())), _defineProperty(_primary, "shadow", "0 0 1px ".concat(safeColor(colors.primary))), _defineProperty(_primary, "focus", "0 0 4px ".concat(safeColor(colors.primary))), _primary),
    primaryRise: {
      variant: 'shadows.primary.rise'
    },
    primaryInset: {
      variant: 'shadows.primary.inset'
    },
    primaryThin: {
      variant: 'shadows.primary.thin'
    },
    primaryThick: {
      variant: 'shadows.primary.thick'
    },
    secondary: (_secondary = {}, _defineProperty(_secondary, THEME_UI_DEFAULT_KEY, "".concat(shadowSettings.qtrBlur, " ").concat(chroma(safeColor(colors.secondary)).alpha(0.2).css())), _defineProperty(_secondary, "rise", "".concat(shadowSettings.qtrBlurRise, " ").concat(chroma(safeColor(colors.secondary)).alpha(0.4).css(), ", 0 0 0 ").concat(borderWidths["default"], " ").concat(chroma(safeColor(colors.secondary)).alpha(0.2).css())), _secondary),
    secondaryRise: {
      variant: 'shadows.secondary.rise'
    },
    whiteRise: "".concat(shadowSettings.qtrBlurRise, " ").concat(chroma(colors.primaries[6]).alpha(0.4).css(), ", 0 0 0 ").concat(borderWidths["default"], " ").concat(chroma(colors.neutrals[17]).alpha(0.2).css()),
    danger: "".concat(shadowSettings.qtrBlur, " ").concat(safeColor(colors.danger)),
    neutral: _defineProperty({}, THEME_UI_DEFAULT_KEY, generateBoxShadow(colors.neutral.darker)),
    cosmos: _defineProperty({}, THEME_UI_DEFAULT_KEY, '2px 5px 15px 0px rgba(0,0,0,0.35)'),
    dropShadow: _defineProperty({}, THEME_UI_DEFAULT_KEY, '2px 4px 6px 0 rgba(0,0,0,0.20)')
  };
}
function borderToShadows(key) {
  switch (key) {
    case 'neutral.medium':
      return 'defaultRise';
    default:
      return key;
  }
}

export default getShadows;
export { borderToShadows, generateBoxShadow, isShadowKey };
//# sourceMappingURL=shadows.esm.js.map
